import { createSelector } from 'reselect';
import { complement, isNil, prop, propEq, propSatisfies } from 'ramda';
import { OverlayType } from './overlay.constants';

export const selectPolicyOverlayDomain = prop('overlay');

export const selectIsOverlayOpen = createSelector(
  selectPolicyOverlayDomain,
  complement(propSatisfies(isNil, 'activeOverlay'))
);

export const selectIsPolicyVisible = createSelector(
  selectPolicyOverlayDomain,
  propEq('activeOverlay', OverlayType.POLICY)
);

export const selectIsPrivacyVisible = createSelector(
  selectPolicyOverlayDomain,
  propEq('activeOverlay', OverlayType.PRIVACY)
);

export const selectIsTermsVisible = createSelector(
  selectPolicyOverlayDomain,
  propEq('activeOverlay', OverlayType.TERMS)
);

export const selectIsCookiesVisible = createSelector(
  selectPolicyOverlayDomain,
  propEq('activeOverlay', OverlayType.COOKIES)
);

export const selectIsOverlayStandalone = createSelector(
  selectPolicyOverlayDomain,
  prop('isStandalone')
);
